module.exports = __webpack_public_path__ + "static/media/optum_place.7e099bc3.jpg";